// extracted by mini-css-extract-plugin
module.exports = {"Subreddits":"Subreddits_Subreddits__vIN8y","header":"Subreddits_header__3nI-i","expandBtn":"Subreddits_expandBtn__1VzPp"};